module.exports = __webpack_public_path__ + "assets/ver.26426c6f8a290fec25d8f1d5aa918f43.svg";


//////////////////
// WEBPACK FOOTER
// ./img/ver.svg
// module id = 936
// module chunks = 0